var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBooksIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Books_icon_svg__clip0_1_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.06 303.762a9.662 9.662 0 01-2.464-.321A9.521 9.521 0 01580.81 299l-22.762-39.44a9.521 9.521 0 013.488-13.012l76.179-43.988a9.508 9.508 0 014.761-1.274c.822 0 1.655.107 2.465.321a9.52 9.52 0 015.785 4.441l22.774 39.44a9.521 9.521 0 01-3.488 13.012l-76.178 43.988a9.512 9.512 0 01-4.762 1.274h-.012z",
    fill: "#46C65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.465 210.81l22.773 39.44-76.178 43.988-22.774-39.44 76.179-43.988zm-.012-19.048c-3.227 0-6.512.821-9.512 2.559l-76.179 43.989a18.981 18.981 0 00-8.869 11.571 19.041 19.041 0 001.905 14.452l22.774 39.441c3.524 6.107 9.928 9.524 16.512 9.524a18.94 18.94 0 009.512-2.56l76.178-43.988a18.98 18.98 0 008.869-11.571 19.04 19.04 0 00-1.905-14.453l-22.773-39.44c-3.524-6.107-9.929-9.524-16.512-9.524z",
    fill: "#1E9561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.727 400.191a9.523 9.523 0 01-8.25-4.762l-22.762-39.441a9.521 9.521 0 013.488-13.012l76.179-43.988a9.518 9.518 0 014.761-1.274 9.521 9.521 0 018.25 4.762l22.774 39.441a9.521 9.521 0 01-3.488 13.012l-76.178 43.988a9.525 9.525 0 01-4.762 1.274h-.012z",
    fill: "#46C65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.143 307.25l22.774 39.44-76.178 43.989-22.774-39.441 76.178-43.988zm0-19.048c-3.309 0-6.607.869-9.523 2.548l-76.179 43.988a19.03 19.03 0 00-8.869 11.571 19.04 19.04 0 001.905 14.453l22.773 39.44c3.524 6.107 9.929 9.524 16.512 9.524 3.227 0 6.512-.821 9.512-2.559l76.179-43.988c9.107-5.262 12.226-16.905 6.976-26.024l-22.774-39.441a19.027 19.027 0 00-11.571-8.869 19.29 19.29 0 00-4.929-.655l-.012.012z",
    fill: "#1E9561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.643 569.762a9.525 9.525 0 01-8.262-4.762l-22.774-39.441a9.526 9.526 0 013.489-13.011l76.178-43.989a9.518 9.518 0 014.762-1.273c.821 0 1.655.107 2.464.321a9.521 9.521 0 015.786 4.441l22.774 39.44a9.522 9.522 0 01-3.488 13.012l-76.179 43.988a9.457 9.457 0 01-4.75 1.274z",
    fill: "#46C65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.048 476.821l22.774 39.441-76.179 43.988-22.774-39.44 76.179-43.989zm-.024-19.059a18.93 18.93 0 00-9.512 2.56l-76.178 43.988a18.983 18.983 0 00-8.87 11.571 19.041 19.041 0 001.905 14.452l22.774 39.441c3.524 6.107 9.929 9.524 16.512 9.524a18.94 18.94 0 009.512-2.56l76.178-43.988a18.98 18.98 0 008.869-11.571 19.044 19.044 0 00-1.904-14.453l-22.774-39.44c-3.524-6.107-9.929-9.524-16.512-9.524z",
    fill: "#1E9561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.086 356.156L539.33 173.573c5.691-3.286 12.977-1.334 16.262 4.357l228.804 396.3c3.286 5.691 1.333 12.976-4.358 16.262L463.795 773.075 223.086 356.156z",
    fill: "#fff",
    stroke: "#CAE0E3",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.357 216.488l-305.94 176.631-21.333-36.952 326.559-188.536-6.417-11.107c-6.571-11.393-21.131-15.286-32.523-8.714L190.619 332.607c-11.393 6.572-15.285 21.131-8.714 32.524l235.214 407.405 39.655 68.678c6.571 11.393 21.131 15.286 32.524 8.715l320.083-184.798c11.393-6.571 15.286-21.131 8.715-32.524L582.881 225.202c-6.571-11.392-21.131-15.285-32.524-8.714z",
    fill: "#F93444",
    stroke: "#E2142D",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.702 513.929h-87.964a9.524 9.524 0 00-9.524 9.524v45.535a9.524 9.524 0 009.524 9.524h87.964a9.524 9.524 0 009.524-9.524v-45.535a9.524 9.524 0 00-9.524-9.524z",
    fill: "#FED425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.702 523.452v45.536h-87.964v-45.536h87.964zm0-19.047h-87.964c-10.524 0-19.048 8.524-19.048 19.047v45.536c0 10.524 8.524 19.048 19.048 19.048h87.964c10.524 0 19.048-8.524 19.048-19.048v-45.536c0-10.523-8.524-19.047-19.048-19.047z",
    fill: "#FD934F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.702 625.286h-87.964c-5.26 0-9.524 4.264-9.524 9.523v45.536a9.524 9.524 0 009.524 9.524h87.964a9.524 9.524 0 009.524-9.524v-45.536c0-5.259-4.264-9.523-9.524-9.523z",
    fill: "#FED425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.702 634.809v45.536h-87.964v-45.536h87.964zm0-19.047h-87.964c-10.524 0-19.048 8.524-19.048 19.047v45.536c0 10.524 8.524 19.048 19.048 19.048h87.964c10.524 0 19.048-8.524 19.048-19.048v-45.536c0-10.523-8.524-19.047-19.048-19.047z",
    fill: "#FD934F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.822 294.667h365.166c6.572 0 11.905 5.333 11.905 11.904v457.607c0 6.572-5.333 11.905-11.905 11.905H278.822V294.667z",
    fill: "#fff",
    stroke: "#CAE0E3",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.095 337.333H278.822v-42.666h377.071v-12.822c0-13.155-10.655-23.809-23.81-23.809H262.488c-13.155 0-23.809 10.654-23.809 23.809v549.738c0 13.155 10.654 23.81 23.809 23.81h369.595c13.155 0 23.81-10.655 23.81-23.81V361.155c0-13.155-10.655-23.81-23.81-23.81l.012-.012z",
    fill: "#95C2C7",
    stroke: "#2A848E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.881 482.869a51.466 51.466 0 00-15.084 36.417v211.393h-55.345V519.286a106.85 106.85 0 0131.298-75.548 106.848 106.848 0 0175.547-31.298 106.879 106.879 0 0175.56 31.298 106.85 106.85 0 0131.298 75.548v211.393h-55.346V519.286a51.515 51.515 0 00-15.083-36.417 51.485 51.485 0 00-72.821 0h-.024z",
    fill: "#006C78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.976 602.488c-3.381-2.488-17.417 3.917-22.845 11.964a5.065 5.065 0 00-3.441-1.369h-4.976c-.667 0-1.321.131-1.94.381a4.882 4.882 0 00-1.512.988c-5.429-8.047-19.476-14.452-22.857-11.964-4.215 3.107-4.655 34.155 0 36.381 3.726 1.774 17.44-4.25 22.821-12.095.452.428.976.774 1.548 1a4.954 4.954 0 001.94.393h4.976c1.298 0 2.536-.5 3.477-1.393 5.38 7.833 19.095 13.869 22.821 12.095 4.667-2.226 4.214-33.274 0-36.381h-.012z",
    fill: "#ED1A3C",
    stroke: "#ED1A3C",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Books_icon_svg__clip0_1_46"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksIcon);
export default ForwardRef;